import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from "@angular/core";

import { SiteService } from "src/app/sites-management/site.service";
import {MatDialog as MatDialog,MatDialogConfig as MatDialogConfig,MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SiteService as SiteManagmentService } from "src/app/new-sites-management/common/services/site.service";
import { MediaService } from "../../common/media.service";
// import { data } from "jquery";
import { MediaUploadDialogComponent } from "../media-upload-dialog/media-upload-dialog.component";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-media-dialog",
  templateUrl: "./media-dialog.component.html",
  styleUrls: ["./media-dialog.component.css"],
})
export class MediaDialogComponent implements OnInit {
  public view: string = "cards";
  public selectedFolderId;

  public fromComponent: boolean = true;
  public width: number = 0;
  public uploadError: string = "";
  public parentId: number = 0;
  public uploads: any[] = [];
  public isUpload: boolean = true;
  public isMultiSelect: boolean = false;
  public fromDialog: boolean = true;
  public files: any[] = [];
  public input: string;
  searchText: any = "";
  selectedFiles: any[] = [];
  @Output() selectedMediaFile = new EventEmitter<any>();
  @Input() selectedMedia;
  constructor(
    public mediaManagerService: MediaService,
    public siteManagmentService: SiteManagmentService,
     private snotifyService: ToastrService,
    public siteService: SiteService,
    public dialogRef: MatDialogRef<MediaDialogComponent>,
    private dialog: MatDialog,

    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.isMultiSelect = data.isMultiSelect;
    this.files = data.files || [];
  }

  ngOnInit() {
    this.mediaManagerService.search.searchText=''
    let folderId=this.mediaManagerService.getfolderId ? this.mediaManagerService.getfolderId :null
    this.mediaManagerService.searchMediaAndFolders(folderId).subscribe((res: any) => {
      this.mediaManagerService.isParentIdChanged(
        res.id,
        res.name,
        res.parentFolderId,
        res.itemCount,
        res.currentFolderBreadcrumb

      );
    });
    this.mediaManagerService.changeParentId.subscribe((value) => {
      this.parentId = value.parentId;
    });
  }

  selectedMediaFiles(data) {
    if (!this.isMultiSelect) {
      this.dialogRef.close(data);
    } else {
      this.selectedFiles = data;
    }
  }



  search() {
    // this.selectedFolders.clear();
   // this.selectedMedia.clear();
    // this.mediaManagerService.filter = { ...this.filter };
    // this.filter.PageNumbermedia = 0;
    // this.filter.PageNumberfolder = 0;
    // this.filter.PageSizefolder = 10;
    // this.filter.PageNumberfolder = 0;
    this.mediaManagerService.searchMediaAndFolders().subscribe((res: any) => {
      // this.totalMediaLength = res.totalCountsMedia;
      // this.totalFolderLength = res.totalCountsFolder;
    });
  }



  done() {
    this.dialogRef.close(this.selectedFiles);
  }
  public onFilesAdded(event, cultureId) {
    this.width = 10;
    var formData = new FormData();
    formData.append("CultureId", cultureId);
    if (this.parentId) {
      formData.append("ParentId", this.parentId.toString());
    }
    for (var i = 0; i < event.addedFiles.length; i++) {
      this.uploads.push(event.addedFiles[i].name);
      formData.append("Uploads", event.addedFiles[i]);
      this.width = 50;
    }

    formData.append("ConvertToWebp", this.mediaManagerService.isWebpForDialogMedia);



    this.mediaManagerService.saveMedia(formData).subscribe(
      (res) => {
        this.width = 100;
        this.mediaManagerService.media$.subscribe();
        this.mediaManagerService.media$.subscribe(
          (res) => (this.selectedFolderId = res.currentFolderId)
        );

        this.mediaManagerService
          .searchMediaAndFolders(this.selectedFolderId)
          .subscribe((res: any) => {
            this.mediaManagerService.isParentIdChanged(
              res.currentFolderId,
              res.currentFolderName,
              res.parentFolderId,
              res.itemCount,
              res.currentFolderBreadcrumb

            );
          });
      },
      (err) => {
        if (err.status == 409) {
          this.replaceMedia(formData);
          this.mediaManagerService.media$.subscribe(
            (res) => (this.selectedFolderId = res.currentFolderId)
          );
          this.mediaManagerService
            .searchMediaAndFolders(this.selectedFolderId)
            .subscribe((res: any) => {
              this.mediaManagerService.isParentIdChanged(
                res.currentFolderId,
                res.currentFolderName,
                res.parentFolderId,
                res.itemCount,
                res.currentFolderBreadcrumb

              );
            });
        } else {
          this.mediaManagerService.media$.subscribe((m: any) => {
            if (m.media) {
              let name = m.media.find(
                (x) => x.filename == event.addedFiles[0].name
              );
              if (name) {
                this.replaceMedia(formData);
              }
            }
          });
          this.mediaManagerService.media$.subscribe(
            (res) => (this.selectedFolderId = res.currentFolderId)
          );
          this.mediaManagerService
            .searchMediaAndFolders(this.selectedFolderId)
            .subscribe((res: any) => {
              this.mediaManagerService.isParentIdChanged(
                res.currentFolderId,
                res.currentFolderName,
                res.parentFolderId,
                res.itemCount,
                res.currentFolderBreadcrumb

              );
            });

          //setTimeout(() => {

          //   this.uploads = [];
          //   this.width = 0;
          // }, 500);
          // this.uploadError = "bg-danger";
        }
      }
    );
  }

  replaceMedia(form: FormData) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    // dialogConfig.panelClass = "modal-media";

    dialogConfig.data = form;
    this.dialog
      .open(MediaUploadDialogComponent, dialogConfig)
      .afterClosed()
      .subscribe((res) => {
        if (res == "replace")
          this.openNotifySuccess("Media replaced Successfuly");
      });
  }
  public openNotifySuccess(message: string) {
    this.snotifyService.success("", message, {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  public getSubItems(id, folder?: any) {
    this.selectedFolderId = id;

    this.mediaManagerService
      .searchMediaAndFolders(folder ? folder.id : 0)
      .subscribe((res: any) => {
        this.mediaManagerService.isParentIdChanged(
          res.currentFolderId,
          res.currentFolderName,
          res.parentFolderId,
          res.itemCount,
          res.currentFolderBreadcrumb
        );
      });
  }
}
